import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueTelInput from 'vue-tel-input'
import axios from 'axios'

axios.defaults.baseURL = "https://apitr.xyz/onlineapi/api/"
Vue.prototype.$axios = axios

Vue.use(VueTelInput)

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
